import { useAtom, useAtomValue } from 'jotai'

import { Currency, useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import {
  Text,
  InputSelectControl,
  Tooltip,
  Flex
} from '@sequencehq/core-components'
import { GreyGrey80, Primary13SemiBold } from '@sequencehq/core-components'
import {
  clientInvoiceAtom,
  isSavePendingAtom
} from 'Invoices/atoms/invoiceEditing.atom'
import { usePaymentProviderForInvoice } from 'Invoices/hooks/usePaymentProviderForInvoice'

export const CurrencySelector = () => {
  const [clientInvoice, partialUpdateInvoice] = useAtom(clientInvoiceAtom)
  const isSavePending = useAtomValue(isSavePendingAtom)
  const paymentProvider = usePaymentProviderForInvoice()

  const accountSettingsQuery = useQuery(
    dashboard20240730Client.getSequenceAccountSettings
  )

  const availableCurrencies = accountSettingsQuery.data?.enabledCurrencies ?? []

  const options = [...new Set(availableCurrencies)].map(currency => ({
    label: currency,
    value: currency
  }))

  const isGoCardlessEnabled = paymentProvider === 'GOCARDLESS'

  if (!clientInvoice) return null

  return (
    <Flex flexDir="column" gap="8px">
      <Text {...Primary13SemiBold} color={GreyGrey80}>
        Currency
      </Text>
      <Tooltip
        label="Currency cannot be changed while GoCardless is enabled"
        isDisabled={!isGoCardlessEnabled}
      >
        <InputSelectControl
          data-testid="currencySelector"
          options={options}
          placeholder="Select currency"
          initialValue={clientInvoice.currency}
          onChange={currency => {
            partialUpdateInvoice({ currency: currency as Currency })
          }}
          disabled={isSavePending || isGoCardlessEnabled}
        />
      </Tooltip>
    </Flex>
  )
}
